import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "mt-4" };
import { detailPages } from '@/constants/workerManagementDetail';
import WorkInfo from '@V/WorkerManagement/WorkerDetail/WorkInfo.vue';
import PrivateInfo from '@V/WorkerManagement/WorkerDetail/PrivateInfo.vue';
import DeliverySetting from '@V/WorkerManagement/WorkerDetail/DeliverySetting.vue';
import { computed, onMounted, onUnmounted, } from 'vue';
import CardSection from '@/components/Common/CardSection.vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const getComp = (n) => ({
            WorkInfo,
            PrivateInfo,
            DeliverySetting,
        }[n]);
        const router = useRouter();
        const route = useRoute();
        const workerDetail = computed(() => vuexStore.state.workerManagement.workerDetail.workerDetail);
        const setPageTitle = () => vuexStore.dispatch('app/setPageTitle');
        const routerPush = (name, values) => {
            const { params, query } = values;
            router.push({
                name,
                params,
                query,
            }).catch(() => { });
        };
        const handleClickReturnBtn = () => {
            const to = routeName.WORKER_MANAGEMENT;
            const value = {
                query: route.query,
            };
            routerPush(to, value);
        };
        const handleClickEditBtn = (type) => {
            const to = routeName.WORKER_MANAGEMENT_WORKER_EDIT;
            const value = {
                params: {
                    code: route.params.code,
                    type,
                },
                query: route.query,
            };
            routerPush(to, value);
        };
        const init = async () => {
            const { code } = route.params;
            await vuexStore.dispatch('workerManagement/workerDetail/getWorkerDetail', code);
            setPageTitle();
        };
        onMounted(() => {
            init();
        });
        onUnmounted(() => {
            vuexStore.dispatch('workerManagement/workerDetail/resetWorkerDetail');
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailPages), ({ title, cardName, type }) => {
                        return (_openBlock(), _createBlock(CardSection, {
                            key: title,
                            title: title,
                            m0: ""
                        }, {
                            titleContent: _withCtx(() => [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    class: "option-ctrl-area",
                                    "data-cy": `${type}-button`,
                                    onClick: ($event) => (handleClickEditBtn(type))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                _createTextVNode(" mdi-pencil-outline ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [0]
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-cy", "onClick"])), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-m": true
                                        }
                                    ]
                                ])
                            ]),
                            default: _withCtx(() => [
                                (workerDetail.value)
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComp(cardName)), {
                                        key: 0,
                                        detail: workerDetail.value,
                                        class: "brg-input-section-dense-wrapper"
                                    }, null, 8 /* PROPS */, ["detail"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createCommentVNode("  "),
                _createCommentVNode(" <CardWrapper\n      :edit-btn-handler=\"handleClickEditBtn\"\n    ></CardWrapper> "),
                _createElementVNode("div", _hoisted_3, [
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        "data-cy": "worker-info-button",
                        class: "list-btn",
                        onClick: handleClickReturnBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { small: "" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" mdi-chevron-left ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                "size-l": true,
                                "width-xs": true
                            }
                        ]
                    ])
                ])
            ]));
        };
    }
});
